import { useSelector } from "react-redux";
import {
  useCancelacionMutation,
  useCatCancelacionesQuery,
} from "../services/docs";
import { RootState } from "../store";
import Button from "./ui/Button";
import { Label } from "./ui/Label";
import { useForm } from "../hooks/useForm";

import { toastr } from "react-redux-toastr";

export const CancelacionComponent = () => {
  const { fi_llamada_id } = useSelector((state: RootState) => state.ui);
  const { data, isLoading } = useCatCancelacionesQuery();
  const [cancelacionAction] = useCancelacionMutation();

  const {
    formulario,
    handleInputChange,
    handleSelectChange,
    handleChangeAll,
    handleTexareChange,
  } = useForm({
    fi_llamada_id: fi_llamada_id,
    fi_motivo: "",
    fc_comentarios: "",
  });

  const generarCancelacion = async () => {
    console.log(formulario);
    if (formulario.fc_comentarios === "") {
      toastr.error("Debe agregar un comentario");
      return;
    }
    const resp = await cancelacionAction({
      ...formulario,
      fi_motivo: +formulario.fi_motivo,
    })
      .unwrap()
      .catch((err: any) => {
        if (err.status === 400) {
          if (err.data.message) {
            if (Array.isArray(err.data.message)) {
              err.data.message.map((m: any) => {
                toastr.error(m);
              });
            } else {
              toastr.error(err.data.message);
            }
          }
        }
        toastr.error(err.message);
        return;
      });
    if (resp) {
      toastr.success(resp.message);
    }
  };

  return (
    <div className="w-full">
      <h1 className="mb-10 rounded-t-xl border-b-2 border-primary py-2 pl-3 text-primary">
        Cancelar Servicio
      </h1>
      <div className="card w-full p-5">
        <h3 className="mb-5 font-bold">Cancelar Servicio</h3>
        {!isLoading && data && (
          <div className="my-5">
            <Label className="my-2" htmlFor="fc_nombre">
              Motivo de Cancelación
            </Label>

            <select
              className="focus-visible:ring-ring flex h-12 w-full items-center justify-between rounded border border-gray-light bg-gray-ultra-light px-3 py-2 text-sm ring-primary-ultra-light file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-50"
              name="fi_motivo"
              onChange={handleSelectChange}
              value={formulario.fi_motivo}
            >
              <option value="">Selecciona el motivo</option>
              {data.cat_cancelaciones.map((c: any) => {
                return (
                  <option key={c.RazonID} value={c.RazonID}>
                    {c.descripcion}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        <div className="my-5">
          <Label htmlFor="fi_tipo_informacion" className="my-2">
            Comentarios:
          </Label>
          <textarea
            className="focus-visible:ring-ring flex h-12 w-full items-center justify-between rounded-xl border border-gray-light bg-gray-ultra-light px-3 py-2 text-base ring-primary-ultra-light file:border-0 file:bg-transparent file:text-sm placeholder:text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2  disabled:cursor-not-allowed disabled:opacity-50"
            onChange={handleTexareChange}
            value={formulario.fc_comentarios}
            name="fc_comentarios"
            id=""
            cols={40}
            rows={2}
          ></textarea>
        </div>
        <div className="my-5">
          <Button onClick={generarCancelacion} className="bg-red-800">
            Generar Cancelación
          </Button>
        </div>
      </div>
    </div>
  );
};
